import * as z from 'zod';

import { AuthorizedContactId, BorrowerId, CompanyId, EntityId, LoanOwnerId, LosId, PoolId } from '../../BrandedIds';
import { zodBrandedString, zodDateOrString } from '../../utils/Zod';
import { ExportableAddress } from '../util/ExportableAddress';

// TODO add more stuff to this object
export const ExportableLoan = z
  .object({
    id: zodBrandedString<LosId>(),
    company: zodBrandedString<CompanyId>(),
    address: ExportableAddress,
    // configuration: LoanConfiguration; // TODO
    originalAmount: z.number(),
    // raw: object; // TODO
    // losId: zodBrandedString<LosId>(), // we use the LosId as the id so the losId field is omitted
    poolId: zodBrandedString<PoolId>().optional(),
    previousServicerId: z.string().optional(),
    capitalPartnerId: z.string().optional(),
    fullId: z.string().optional(),
    otherId1: z.string().optional(),
    otherId2: z.string().optional(),
    otherId3: z.string().optional(),
    ownerId: zodBrandedString<LoanOwnerId>().optional(),
    noteflowId: z.string().optional(),
    primaryBorrower: zodBrandedString<BorrowerId>(),
    additionalBorrowers: zodBrandedString<BorrowerId>().array(),
    entityId: zodBrandedString<EntityId>().optional(),
    authorizedContacts: zodBrandedString<AuthorizedContactId>().array(),
    // externalIdHistory: { // TODO
    //   poolId: ExternalIdHistory[];
    //   previousServicerId: ExternalIdHistory[];
    //   capitalPartnerId: ExternalIdHistory[];
    //   fullId: ExternalIdHistory[];
    //   otherId1: ExternalIdHistory[];
    //   otherId2: ExternalIdHistory[];
    //   otherId3: ExternalIdHistory[];
    //   ownerId: ExternalIdHistory[];
    // };
    createdAt: zodDateOrString,
    updatedAt: zodDateOrString,
    archivedAt: zodDateOrString.optional(),
  })
  .meta({ title: 'Loan' });

export type ExportableLoan = z.infer<typeof ExportableLoan>;
